var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99793 6L9.79119 3.20674C9.92376 3.0744 9.99833 2.89483 9.99849 2.70751C9.99866 2.5202 9.92441 2.34049 9.79207 2.20793C9.65974 2.07536 9.48016 2.00079 9.29285 2.00062C9.10554 2.00046 8.92583 2.07471 8.79326 2.20704L6 5.00031L3.20674 2.20704C3.07417 2.07448 2.89437 2 2.70689 2C2.51941 2 2.33961 2.07448 2.20704 2.20704C2.07448 2.33961 2 2.51941 2 2.70689C2 2.89437 2.07448 3.07417 2.20704 3.20674L5.00031 6L2.20704 8.79326C2.07448 8.92583 2 9.10563 2 9.29311C2 9.48059 2.07448 9.66039 2.20704 9.79296C2.33961 9.92552 2.51941 10 2.70689 10C2.89437 10 3.07417 9.92552 3.20674 9.79296L6 6.99969L8.79326 9.79296C8.92583 9.92552 9.10563 10 9.29311 10C9.48059 10 9.66039 9.92552 9.79296 9.79296C9.92552 9.66039 10 9.48059 10 9.29311C10 9.10563 9.92552 8.92583 9.79296 8.79326L6.99793 6Z",
    fill: "#6D7176"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.02756f94163189ad995e5a4be7436775.svg";
export { ForwardRef as ReactComponent };